import { Client, RawClient } from './typings';

export const serializeClientForFront = (data: RawClient): Client => ({
  id: data.id,
  name: data.fields.Name,
  logo: data.fields.Logo && data.fields.Logo[0],
  projects: data.fields.Projet,
  clientOwner: data.fields['Owner du client'],
});
